import { render, staticRenderFns } from "./FirstTimeBuyer.vue?vue&type=template&id=bb14c4fc"
import script from "./FirstTimeBuyer.vue?vue&type=script&lang=js"
export * from "./FirstTimeBuyer.vue?vue&type=script&lang=js"
import style0 from "./FirstTimeBuyer.vue?vue&type=style&index=0&id=bb14c4fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports